import { DEFAULT_LANG, isSupported } from './languages';

const lookup = (dict, key) => key.split('.').reduce((o, k) => (o == null ? undefined : o[k]), dict);

function pick(dict, lang, key, vars) {
  if (!dict) return undefined;
  if (vars && typeof vars.count === 'number') {
    const form = new Intl.PluralRules(lang).select(vars.count);
    const v = lookup(dict, `${key}_${form}`) ?? lookup(dict, `${key}_other`);
    if (typeof v === 'string') return v;
  }
  const v = lookup(dict, key);
  return typeof v === 'string' ? v : undefined;
}

export function translate(dicts, lang, key, vars) {
  const raw = pick(dicts[lang], lang, key, vars)
    ?? pick(dicts[DEFAULT_LANG], DEFAULT_LANG, key, vars)
    ?? key;
  if (!vars) return raw;
  return raw.replace(/\{(\w+)\}/g, (m, name) => (vars[name] === undefined ? m : String(vars[name])));
}

export function resolveInitialLang({ profileLang, storedLang, navigatorLangs = [] }) {
  for (const c of [profileLang, storedLang]) if (isSupported(c)) return c;
  for (const n of navigatorLangs || []) {
    const base = String(n || '').slice(0, 2).toLowerCase();
    if (isSupported(base)) return base;
  }
  return DEFAULT_LANG;
}
